import { DialogContent } from '@mui/material'
import { t } from 'i18next'

import CustomDialog from '@/components/feedback/CustomDialog'
import { RestrictionDetailsForm } from '@/features/site/components/availability/restriction/form/RestrictionDetailsForm'
import type { MarketProgram } from '@/features/site/types/marketProgram'
import type { Restriction } from '@/features/unavailability/types/restriction'

interface RestrictionDetailsEditDialogProps {
  open: boolean
  onClose: () => void
  marketProgram: MarketProgram
  customerTimeZone: string
  customerLocation: string
  customerUuid: string
  restriction: Restriction
}

export const RestrictionDetailsEditDialog = (props: RestrictionDetailsEditDialogProps) => {
  return (
    <CustomDialog
      open={props.open}
      size="large"
      title={t('customer_details.tabs.availability.unavailability_form.edit_dialog.title')}
      onClose={props.onClose}
    >
      <DialogContent>
        <RestrictionDetailsForm
          customerLocation={props.customerLocation}
          customerTimeZone={props.customerTimeZone}
          customerUuid={props.customerUuid}
          marketProgram={props.marketProgram}
          restriction={props.restriction}
          onClose={props.onClose}
        />
      </DialogContent>
    </CustomDialog>
  )
}
